__webpack_require__.p = "https://centralsoft.com.my/";